module.exports = __webpack_public_path__ + "img/greenBG.037b0468.jpg";